// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKING!
export const VERSION = {
    "dirty": false,
    "raw": "v1.7.9-0-g02327557",
    "hash": "g02327557",
    "distance": 0,
    "tag": "v1.7.9",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.7.9",
        "major": 1,
        "minor": 7,
        "patch": 9,
        "prerelease": [],
        "build": [],
        "version": "1.7.9"
    },
    "suffix": "0-g02327557",
    "semverString": "1.7.9",
    "version": "1.7.9",
    "versionDateTime": "2026-09-30T06:31:55.637Z"
};
